export const HEX_REGEX = /^(0x)?[0-9a-fA-F]+$/;
export const FORTY_DIGITS_HEX = /^0x[0-9a-fA-F]{40}$/;
export const TOKEN_AMOUNT_REGEX = /^(?<lead>\d+)(?<body>[,\d*]*)[.]*[\d]*\s(?<symbol>[A-Za-z]+)$/;
